import { render, staticRenderFns } from "./exhibition-template-service.vue?vue&type=template&id=792ff93e&scoped=true&"
import script from "./exhibition-template-service.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-service.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-service.vue?vue&type=style&index=0&id=792ff93e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ff93e",
  null
  
)

export default component.exports